function currentYear() {
	const yearSpan = document.querySelector(".footer__year");
	if (yearSpan) {
		yearSpan.innerHTML = new Date().getFullYear();
	}
}

export default currentYear;
